const API = process.env.REACT_APP_BACKEND_URL;

export const trackEvent = (kind) => {
  fetch(`${API}/api/app-events`, {
    method: "POST", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ kind }),
  }).catch(() => {});
};
